var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DublettenFilterPanel',{attrs:{"optionsArray":_vm.agenturDuplicatesIdFilterOptions,"storeFunction":_vm.getAgenturFilterFunction,"placeholder":_vm.$t('AGENTUREN.AGENTURNUMMER'),"objectName":"Agentur","stateOptions":_vm.stateOptions,"appliedIds":_vm.appliedFilter.idFilter,"appliedState":_vm.appliedFilter.duplicateState},on:{"apply":_vm.onApply}})
}
var staticRenderFns = []

export { render, staticRenderFns }